<div *ngIf="!multiple" class="row" style="width: 100%;">
    <div class="col-6 d-flex flex-column align-items-start">
        <paf-combobox  *ngIf="showRegions"
            headerPafLabel="Region"
            class="mr-2" 
            style="width:100%;" 
            [data]="lstRegions"
            [(ngModel)]="regionId" 
            [ngModelOptions]="{ standalone: true }"
            [required]="required"
            (selectedObjectChange)="updateLstDpts($event)">
            
        </paf-combobox>
    </div>
    <div class="col-6 d-flex flex-column align-items-start">
        <paf-combobox  *ngIf="showDepartments"
            headerPafLabel="Departement"
            style="width:100%;" 
            [data]="parsedDpts"
            [(ngModel)]="dptId" 
            [ngModelOptions]="{ standalone: true }"
            [required]="required">            
        </paf-combobox>
    </div>
</div>

<div *ngIf="multiple" class="row" style="width: 100%;">
    <div class="col-6 d-flex flex-column align-items-start">
        <label *ngIf="showRegions" class="control-label" paflabel="Regions"></label>
        <kendo-multiselect *ngIf="showRegions"
            class="form-control" 
            [valuePrimitive]="true"
            name="regionIds" 
            [data]="lstRegions"
            [(ngModel)]="multiselectRegionsModel" 
            [ngModelOptions]="{ standalone: true }"
            [filterable]="true"
            [kendoDropDownFilter]="filterSettings"
            [allowCustom]="false"
            textField="comboDisplay"
            valueField="Id"
            #regionIds>
        </kendo-multiselect>
    </div>
    <div class="col-6 d-flex flex-column align-items-start">
        <label *ngIf="showDepartments" class="control-label" paflabel="Departements"></label>
        <kendo-multiselect  *ngIf="showDepartments" 
            class="form-control" 
            [valuePrimitive]="true"
            name="departmentIds" 
            [data]="lstDptsFiltered"
            [filterable]="true"
            (filterChange)="handleFilterDpt($event)"
            [kendoDropDownFilter]="filterSettings"
            [(ngModel)]="multiselectDptsModel" 
            [ngModelOptions]="{ standalone: true }"
            [allowCustom]="false"
            textField="comboDisplay"
            valueField="Id"
            #departmentIds>
        </kendo-multiselect>
    </div>
</div>